<template>
  <div class="h5_mobile" >
    <el-dialog
    :visible.sync="dialogVisible"
    width="70%"
    >
     <template>
      <el-table
        :data="tableList"
        size='mini'
        border
        height='450'
        :default-sort = "{prop: 'surgeIndex', order: 'descending'}"
        style="width: 100%;height:450px">
        <el-table-column :label="$t('other.a1728')" width="100">
          <template slot-scope="scope">
            <div class="picbox" >
              <img style="width:100%" :title="scope.row.name" :src="getImageUrlCopy(conturyCode,scope.row.image)" @click="toGoodsDetailPage(scope.row.shopid, scope.row.itemid)" >
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="surgeIndex" sortable :label="$t('other.a1729')">
          <template slot-scope="scope">
            <span>{{scope.row.surgeIndex}}</span>
          </template>
        </el-table-column>
         <el-table-column :label="$t('other.a1730')" sortable>
          <template slot-scope="scope">
            <span>{{scope.row.sold}}</span>
          </template>
        </el-table-column>
         <el-table-column :label="$t('other.a1731')" sortable>
          <template slot-scope="scope">
            <span>
              {{
                '¥' +
                  getMonthTotalSales(
                    scope.row.models,
                    scope.row.currency,
                    scope.row.price_max,
                    scope.row.price_min,
                    scope.row.sold,
                  )
              }}
            </span>
          </template>
        </el-table-column>
         <el-table-column :label="$t('other.a1732')" sortable>
          <template slot-scope="scope">
            <span>{{getDayNum(scope.row.ctime)}}</span>
          </template>
        </el-table-column>
         <el-table-column :label="$t('other.a1733')" sortable>
          <template slot-scope="scope">
            <span> ¥ {{getLatestRMBPrice(scope.row.price_min,scope.row.currency)}}</span>
          </template>
        </el-table-column>
         <el-table-column :label="$t('other.a1734')" sortable>
          <template slot-scope="scope">
            <span>{{getConversionRate(scope.row.sold,scope.row.view_count)}}</span>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{$t('other.a106')}}</el-button>
      <el-button type="primary" @click="dialogVisible = false">{{$t('other.a279')}}</el-button>
    </span>
  </el-dialog>
    <div ref="header" :class="{'header_title':true,'header_active':kjvhjf}">
      <div class="loginInfo">
      </div>
      <div class="header_center">
        <div class="dianxiaoshen">{{$t('other.a406')}}{{$t('other.a416')}}</div>
        <div>
          <ul>
            <li class="li_desc active">{{$t('other.a1762')}}</li>
            <li class="li_desc" @click="support()">{{$t('other.a1763')}}</li>
            <li class="li_desc" @click="hanAgent()">{{$t('other.a340')}}</li>
            <li class="li_desc" @mouseenter="show=true" @mouseleave="show=false">
              {{$t('other.a1764')}}
              <ul v-show="show" class="customer">
                <li>
                  <div class="img_box animated fadeIn"><img style="width:100%" src="../../assets/img/kefu2.png" alt=""></div></li>
              </ul>
            </li>
            <li class="li_desc" >
              <span v-show="!hasLoginUserName" @click="singnIn()" class="sign_box">{{$t('other.a1765')}}</span>
              <span v-show="hasLoginUserName" >{{hasLoginUserName}}</span>
            </li>
            <li  class="li_desc" v-show="hasLoginUserName">
              <span style="margin-left:-20px;font-size:12px;color:#000"  @click="singnOut()">{{$t('other.a1766')}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="home_box">
      <div class="title">
        <p class="title_desc animated fadeInDownBig">{{$t('other.a406')}}<br />{{$t('other.a1767')}}</p>
        <p class="title_desc animated rollIn">{{$t('other.a1768')}}</p>
        <p class="title_desc animated rollIn">{{$t('other.a1769')}}</p>
        <p class="title_desc animated rollIn">{{$t('other.a1770')}}</p>
        <div class="title_desc">
          <div class=" animated fadeInRight">{{$t('other.a1771')}}</div>
          
          <div class="userNmae animated fadeInRight">{{userName}}</div>
        </div>
      </div>
    </div>
    <div class="recommend">{{$t('other.a1772')}}</div>
    <div class="item_wrapper">
      <div class="item_data"   v-for="(item,index) in DataList" :key="index">
        <div class="pic_box"><img :src="item.image" /></div>
        <div class="item_desc">{{item.groupName}}</div>
        <div class="item_text">{{$t('other.a1713')}}：￥{{item.minPrice}}</div>
        <div class="item_text">{{$t('other.a1740')}}：{{item.amount >= 0 ? item.amount : 0}}</div>
        <div class="item_button" >
          <span class="remoteview" @click="remote(item)">{{$t('other.a1773')}}</span>
          <span class="country">{{$t('other.a1774')}}：{{country(item.country)}}</span>
          <span class="button" @click="viewDetail(item)">{{$t('other.a1742')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/api'
import utils from '../../utils/utils'
import newOrders from '../../api/moudles/newOrders'
import { Alert } from 'element-ui'

export default {
data(){
  return{
    userName:'',
    DataList:[],
    userId:null,
    active:0,
    kjvhjf:false,
    hasLoginUserName:null,
    show:false,
    show2:false,
    dialogVisible:false,
    storeItem:null,
    tableList:[],
    conturyCode:'th',
    mainImg:{
      image:null,
      url:null,
      name:null
    },
    
    
  }
},
created(){
 this.hasLogin()
 this.getData()
},

mounted() {
     window.addEventListener('scroll', this.getScroll)
},

methods:{

    openNew(){
      window.open(this.mainImg.url)
    },
     toGoodsDetailPage(shopid, itemid) {
      let newUrl = 'https://shopee.ph/~-i.' + shopid + '.' + itemid
      window.open(newUrl)
    },
  // 计算月销售额
    getMonthTotalSales(models, currency, price_max, price_min, sold) {

      let ttp=null
      if (models && models.length) {
        // 计算平均值
        let result = utils.calculateAverage(models, 'price')
        ttp =utils.parseRate(result, currency)
        
      }else{
        ttp= utils.parseRate((price_max + price_min) / 2, currency)
      }
      
      return parseInt(ttp * sold)
    },
  //获取日期间隔
  getDayNum(time) {
    let added = new Date(time * 1000)
    let today = new Date()
    let dayNum = parseInt(Math.abs(today - added) / 1000 / 60 / 60 / 24)
    return dayNum
      
  },
  // 计算最低售价 原始价格
  getLatestOriginPrice(price) {
      return (price / 100000).toFixed(1)
    },
  //转化指数
  getConversionRate(sold, count) {
    if (count === 0) {
      return '0.00%'
    }
    return ((sold / count) * 100).toFixed(2) + '%'
  },

  getImageUrlCopy(contury,image){
      return utils.getImageUrl(contury,image)
  },
  remote(item){
    
    console.log(item)
    api
    .getStoreItemByGroupId({groupId:item.groupId})
    .then(res => {
    if(res.code === 200 ){
      console.log('storeitem',res.data)
        this.storeItem=res.data

        this.mainImg.image=item.image
        this.mainImg.name=item.groupName
        this.mainImg.url='https://shopee.ph/~-i.' + this.storeItem.categoryData.shopId + '.' + this.storeItem.categoryData.itemId
        let falg=false
        for(let key in res.data.categoryData){
          console.log(res.data.categoryData[key])
          if(!res.data.categoryData[key]){
            falg=true
          }
        }
        console.log(falg)
        if(falg){
          this.$dialog.alert({
            message: this.$t('other.a1743'),
            title:this.$t("other.a142")
            });

        }

        if(!falg){
          let str='catid='+this.storeItem.categoryData.catId+'&itemid='+this.storeItem.categoryData.itemId+'&shopid='+this.storeItem.categoryData.shopId
          let url=utils.getSimilaryData(this.storeItem.country.toLowerCase(),str)
          this.conturyCode=this.storeItem.country.toLowerCase()

          newOrders
          .proxyHttps({
              type:0,
              url:url,
              headerMap:null,
          })
          .then(res => {
           this.tableList=res.data.sections.similar_product.data.item
          let temp=null
          this.tableList.forEach(e => {
            let saleDays = utils.getMin(30, utils.getDayInterval(e.ctime))
            if (saleDays === 0) {
              temp = 0
            } else {
              let averagePrice = utils.calculateAveragePrice(
                e.models,
                e.currency,
                e.price_max,
                e.price_min,
              )
              temp = parseInt(
                utils.calculateTotalSales(averagePrice, e.sold) / saleDays
              )
            }
            e.surgeIndex = temp
          })
         
           this.dialogVisible=true
           console.log('11',this.tableList)
          })
        }
        
    }else{
      this.$message.warning(res.msg)
    }
    })
   

  },
  support(){
    if(this.hasLoginUserName){
      this.$router.push('/distributeProduct/myselfproduct')
    }else{
      this.$confirm(this.$t('other.a1775'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a1765'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
          this.singnIn()
       
        })
         return
    }
  },
  hanAgent(){
    if(this.hasLoginUserName){
      this.$router.push('/distributeProduct/hasAgent')
    }else{
      this.$confirm(this.$t('other.a1775'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a1765'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
          this.singnIn()
       
        })
         return
    }
  },
  singnOut(){
    localStorage.removeItem('userInfo')
      this.$message.success(this.$t('other.a1776'))
      this.hasLoginUserName=null
  },
  hasLogin(){
    let userData=JSON.parse(localStorage.getItem('userInfo'))
    if(userData){
      this.hasLoginUserName=userData.userName
    }
  },


  getScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop > 0){
        this.kjvhjf=true
      }else{
        this.kjvhjf=false
      }
    },

  country(id){
    return utils.conutryConversion(id)
  },
  singnIn(){
     this.$router.push({
          path:'/loginPage',
          query:{
            invitationCode:this.$route.query.invitationCode,
            fromh5:'456852'
          }
        })
  },

  getLatestRMBPrice(price, currency) {
      return utils.parseRate(price, currency).toFixed(1)
    },

  register(){
     this.$router.push({
          path:'/userRegistor',
          query:{
            invitationCode:this.$route.query.invitationCode,
            fromh5:'456852'
          }
        })
  },
  viewDetail(item){
    let userData=JSON.parse(localStorage.getItem('userInfo'))
    if(!userData){
      if(utils.judgePcOrAndirod()){
        this.$toast(this.$t('other.a1777'))
        this.$router.push({
          path:'/mh5/login',
          query:{
            invitationCode:this.$route.query.invitationCode
          }
        })
        return

      }else{
        this.$confirm(this.$t('other.a1775'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a1765'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
          this.singnIn()
       
        })
         return
      }

    }
    if(utils.judgePcOrAndirod()){
      this.$router.push({
        path:'/mh5/productDetail',
        query:{
          groupId:item.groupId,
          productId:item.productId,
          invitationCode:this.$route.query.invitationCode
        }
        
        })
    }else{
      
        let storeItem=JSON.parse(JSON.stringify(item))
        let id=storeItem.userId
        let userId=userData.userId
        if(id == userId){
            this.$confirm($t('other.a1703'), this.$t("other.a142"), {
            confirmButtonText: this.$t("other.a884"),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
            }).then(() => {})
            return
        }

        storeItem.userId=JSON.parse(localStorage.getItem('userInfo')).userId
        
        api
        .copyStoreItem(storeItem)
        .then(res => {
          if(res.code === 200) {
            this.$message.success(this.$t('other.a1778'))
            // this.$dialog.alert({
            // message: $t('other.a1749'),
            // title:$t('other.a1708')
            // });
            
          }else{
            this.$dialog.alert({
                message: res.msg,
                title:$t('other.a1709')
                });
          }
        })
    }
  },

  getData(){
    
    if(this.$route.query.invitationCode){
      newOrders
      .getUserInviteeByCode({
        code:this.$route.query.invitationCode
      })
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',res.data)
      this.userName=res.data.inviter
      this.userId=res.data.userId
      document.title =this.$t('other.a1779')+ res.data.inviter + this.$t('other.a1780')
      if(res.data.userId){
          api
          .getPublicStoreItem({
            categoryIds:[],
            name:null,
            offset:200,
            page:0,
            sortType:0,
            userId:res.data.userId
          })
          .then(res => {
          if(res.code === 200 ){
          console.log('desc',res.data)
          this.DataList=res.data.groups
          }else{
          this.$message.warning(res.msg)
          }
          })
      }
  
        
      }else{
      this.$message.warning(res.msg)
      }
      })

    }else{//获取全部的分销产品
    
          api
          .getPublicStoreItem({
            categoryIds:[],
            name:null,
            offset:200,
            page:0,
            sortType:0,
            userId:null
          })
          .then(res => {
          if(res.code === 200 ){
          console.log('desc',res.data)
          this.DataList=res.data.groups
          }else{
          this.$message.warning(res.msg)
          }
          })
    }
    

    
    
  },

  country(id){
    return utils.conutryConversion(id)
  },
  viewDetail(item){
    let userData=JSON.parse(localStorage.getItem('userInfo'))

    if(!userData){
      this.$toast(this.$t('other.a1777'))
      this.$router.push({
        path:'/mh5/login',
        query:{
          invitationCode:this.$route.query.invitationCode
        }
      })
      return
    }
    this.$router.push({
      path:'/mh5/productDetail',
      query:{
        groupId:item.groupId,
        productId:item.productId,
        invitationCode:this.$route.query.invitationCode
      }
      
      })
  },

  // getData(){
    
  //   newOrders
  //   .getUserInviteeByCode({
  //     code:this.$route.query.invitationCode
  //   })
  //   .then(res => {
  //   if(res.code === 200 ){
  //   console.log('desc',res.data)
  //   this.userName=res.data.inviter
  //   this.userId=res.data.userId
  //   document.title =this.$t('other.a1779')+ res.data.inviter + this.$t('other.a1780')
  //   if(res.data.userId){
  //       api
  //       .getPublicStoreItem({
  //         categoryIds:[],
  //         name:null,
  //         offset:50,
  //         page:0,
  //         sortType:0,
  //         userId:res.data.userId
  //       })
  //       .then(res => {
  //       if(res.code === 200 ){
  //       console.log('desc',res.data)
  //       this.DataList=res.data.groups
  //       }else{
  //       this.$message.warning(res.msg)
  //       }
  //       })
  //   }

      
  //   }else{
  //   this.$message.warning(res.msg)
  //   }
  //   })

    
    
  // }

}
}

</script>
<style lang="scss" scoped>

@media (min-width: 1200px)  {
      .h5_mobile{
        background: #eee;
        min-height: 100vh;
        font-size: 18px;
        position: relative;
        background-color: #409eff;
        padding-bottom: 150px;

       


        /deep/ .el-dialog__body{
          margin-top: 10px;
          padding:0 10px
        }

        /deep/ .el-dialog__title{
          display: inline-block;
          width: 250px;
          height: 47px;
          background-image: url('../../assets/img/pic/shopeelogo.png');
          background-repeat: no-repeat;
          background-size: 60%;
        }
        /deep/ .el-icon-close{
          color: #eee;
          font-size: 25px;
        }

        /deep/ .el-dialog__header{
          padding: 20px 20px 10px;
          background: linear-gradient( 
          -180deg
          ,#f53d2d,#f63);
          
        }

        .outerBox{
          display: flex;
          margin-bottom: 20px;
          padding-left: 20px;
          
          .dataDesc{
            margin: 0 36px;
            font-size: 18px;
          }

          


          .mainpic{
            width: 120px;
            height: 120px;
            overflow: hidden;
            margin-right: 30px;
            
            img{
              width: 100%;
            }
          }

        }

        

        .picbox{
          width: 50px;
          height: 50px;
          overflow: hidden;
          cursor: pointer;
         
        }

        .title{
          position: relative;
          top: 95px;
          left: 150px;
          padding-left:30px ;

          .title_desc:nth-child(1){
              color: #fff;
              font-weight: bold;
              font-size: 3rem;
            }

            .title_desc:nth-child(2){
              margin: 0.5rem 0;
              color: #000;
              font-size: 1.5rem;
            }

            .title_desc:nth-child(3){
            margin: 1rem 0;
              color: #000;
              font-size: 1.5rem;
            }

            .title_desc:nth-child(4){
              margin: 0.1rem 0;
              color: #000;
              font-size: 1.5rem;
            }

            .title_desc:nth-child(5){
              position: absolute;
              right: 1.9rem;
              bottom: -3.5rem;
              // color: yellow;
             

              .userNmae{
                color: #fff;
                text-align: center;
                font-size: 0.9rem;
              }
              
            }



        }
        .header_active{
           background-color: #409eff;
           color: #000;
           z-index: 99999;
        }

        .header_title{
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          margin:0 auto;
          width: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          border-bottom: 1px solid #fff;


          .loginInfo{
            width: 1200px;
            color: rgb(27, 27, 27);
            font-size: 13px;
            font-weight: bold;
            padding: 2px 0;
            text-align: right;

            .umvjf{
              margin-right: 15px;
              cursor: pointer;
            }


          }
          

          .header_center{
            display: flex;
          justify-content: space-between;
          align-items: center;
          z-index: 99;
            width: 1200px;
          }

          .active{
              color: #fff;
              background: none;
            }
         
          

          .li_desc{
            float: left;
            padding: 0 15px;
            cursor: pointer;
            font-weight: bold;
            position: relative;

            .sign_box{
              border:1px solid #000;
              background-color: #fff;
              padding:10px 35px;
              border-radius: 20px;
              font-size: 16px;
            }

            .sign_box:hover{
              background-image: linear-gradient(90deg,#e83e8c, #f3accd);;
            }


            .customer{
              position: absolute;
              top: 45px;
              right: 0;

              .img_box{
                width: 200px;
                height: 200px;
                overflow: hidden;
              }
            }

            
          }

          .li_desc:hover{
            color: #fff;
          }

          

          .dianxiaoshen{
            font-size: 25px;
            font-weight: bold;
            padding: 16px 0;



          }

          
        }

        

        .home_box{
        background-image: url('../../assets/img/2.png') ;
        width:100%;
        height: 25.5rem;
        background-repeat:no-repeat;
        background-size: 100%;
        background-position: 10% 100%;

       

        }

         .recommend{
          text-align: center;
          font-size: 2rem;
          color: #fff;
          padding: 20px 0;
        }

        .item_wrapper{
          width: 1200px;
          //  position: absolute;
          //   left: 0;
          //   right: 0;
            margin:0 auto;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            background-color: #409eff;

          .item_data{
            width: 14rem;
            background-color: #fff;
            margin-right: 10px;
            margin-bottom: 10px;
            border-radius: 5px;
            
          }

          .item_button{
            text-align: right;
            width: 100%;
            margin-bottom:10px;
            display: flex;
            justify-content: space-between;

            .country{
            
              display: none;
              font-size: 15px;
              color: red;
              padding:5px
            }


            .button{
              color: #fff;
              background-color: #ff6034;
              border-radius: 2px;
              box-sizing: border-box;
              padding: 2px 3px;
              margin-right: 2px;
              cursor: pointer;
              font-size: 15px;
            
            }
            .remoteview{
              font-size: 14px;
              color: #409eff;
              cursor: pointer;
              padding:5px 2px;
              
            }
            
          }

          .item_desc{
            width: 12rem;
            height: 2.7rem;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            line-clamp: 2;
            -webkit-box-orient:vertical;
            font-size: 10px;
            box-sizing: border-box;
            padding: 10px;
            

          }

          .item_text{
            padding:0 0 5px  5px;
          }

          .pic_box{
            width: 13rem;
            height: 13rem;
            overflow: hidden;
            margin: 0 auto;
            margin-top: 10px;



            img{
              width: 100%;;
            }
          }
        }
        
      }
}






@media (min-width: 575px) and (max-width: 991px)   {
        .h5_mobile{
        background: #409eff;
        height: 100vh;
        font-size: 18px;
        color: red;


        
      }







}





@media (max-width: 575px)  {
  html{
    font-size: 25px;
  }


  
  .header_title{
    display: none;
  }

  .remoteview{
    display: none;
  }



  .home_box{
    background-image: url('../../assets/img/h5_home.png') ;
    width:100%;
    height: 15rem;
     background-repeat:no-repeat;
    background-size: 100%;
    background-position: 10% 100%;



    .title{
      font-size: 1rem;
      font-weight:bold;
      color: #fff;
      position: relative;

      


  
      


      .title_desc{
        text-align: left;
        box-sizing: border-box;
        padding-left: 0.5rem;
      }

      .title_desc:nth-child(1){
        margin-bottom: 0.1rem;
        padding: 0.3rem 0;
        box-sizing: border-box;
        padding-left: 0.5rem;
        font-size: 1.2rem;
      }

      .title_desc:nth-child(2){
        margin: 0.1rem 0;
        color: #000;
        font-size: 0.8rem;
      }

      .title_desc:nth-child(3){
       margin: 0.1rem 0;
        color: #000;
        font-size: 0.8rem;
      }

      .title_desc:nth-child(4){
        margin: 0.1rem 0;
        color: #000;
        font-size: 0.8rem;
      }

      .title_desc:nth-child(5){
        position: absolute;
        right: 1.1rem;
        bottom: -4.0rem;
        color: yellow;
        text-align: center;

        .userNmae{
          color: #fff;
          text-align: center;
          font-size: 0.9rem;
        }
        
      }

      
    }
   
  }

      .h5_mobile{
        background: #409eff;
        min-height: 100vh;
        font-size: 18px;  
        padding-bottom: 2rem; 
      }

      .recommend{
        width:100%;
        text-align: center;
        font-size: 1rem;
        color: #fff;
        font-weight: bold;
        margin: 10px 0;
      }

      img{
        width: 100%
      }

      .item_wrapper{
        display: flex;
        justify-content: flex-start;
        box-sizing: border-box;
        margin: 0 10px;
        flex-wrap: wrap;


        
      

        .item_data{
          width:48%;
          background: #fff;
          border-radius: 5px;
          display: flex;
          flex-direction: column;
          align-items: center;
           margin-right: 5px ;
          margin-bottom: 5px ;
          font-size: 0.6rem;
        }

        .item_desc{
          margin: 5px 0;
          box-sizing: border-box;
          padding: 5px 10px;
          height: 3rem;
          overflow: hidden;
          color: rgb(95, 95, 95);
          width: 100%;
        }

        .item_text{
          width: 100%;
          text-align: left;
          padding-left:15px;
          margin-bottom:5px
        }

        .item_button{
          text-align: right;
          width: 100%;
          margin-bottom:10px;
          display: flex;
          justify-content: space-between;


          .country{
           
           
            font-size: 10px;
            color: red;
            padding:5px
          }


          .button{
            color: #fff;
            background-color: #ff6034;
            border-radius: 2px;
            box-sizing: border-box;
            padding: 2px 3px;
            margin-right: 2px;
           
          }

          
          
        }
      }


      .pic_box{
        width: 6rem;
        height: 6rem;
        overflow: hidden;
      }
}





</style>